import script from "./PortalFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalFooter.vue?vue&type=script&setup=true&lang=js"

import "./PortalFooter.vue?vue&type=style&index=0&id=350aeba1&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350aeba1"]])

export default __exports__